import { useEffect, useRef } from "react";
import { postMethodByCallBack } from "../store/api/CommonFunctions";

function LocationSender() {
    const lastSentLocation = useRef(getLastLocationFromStorage());
    const latestLocation = useRef(null);

    function getLastLocationFromStorage() {
        const stored = localStorage.getItem('lastSentLocation');
        return stored ? JSON.parse(stored) : null;
    }

    function updateLastLocationStorage(location) {
        localStorage.setItem('lastSentLocation', JSON.stringify(location));
    }

    useEffect(() => {
        if (!navigator.geolocation) {
            console.error('Geolocation پشتیبانی نمی‌شود');
            return;
        }

        const successCallback = position => {
            const { latitude, longitude } = position.coords;
            latestLocation.current = { latitude, longitude };
        };

        const errorCallback = error => {
            console.error('خطای موقعیت:', error.message);
        };

        const watchId = navigator.geolocation.watchPosition(successCallback, errorCallback, {
            enableHighAccuracy: true,
            maximumAge: 10000,
            timeout: 5000,
        });

        const intervalId = setInterval(() => {
            if (
                latestLocation.current &&
                JSON.stringify(latestLocation.current) !== JSON.stringify(lastSentLocation.current)
            ) {
                sendLocation(latestLocation.current);
                lastSentLocation.current = { ...latestLocation.current };
                updateLastLocationStorage(lastSentLocation.current);
            }
        }, 10000); // هر ۱۰ ثانیه

        return () => {
            navigator.geolocation.clearWatch(watchId);
            clearInterval(intervalId);
        };
    }, []);

    const sendLocation = (loc) => {
        const locData = { Latitude: loc.latitude, Longitude: loc.longitude };
        postMethodByCallBack("api/LocationAPI/LiveLocation", locData, ()=>{}, "LiveLocation");
    };

    return null;
}

export default LocationSender;